import React from "react";

export default function RequiredDocuments({ data }) {
  return (
    <div className="howToInvestWrapper">
      <h3 className="heading-1-bold tableTitle">{data.heading}</h3>
      <p className="para-2 tableDesc">{data.desc_p1}</p>
      <p className="para-2 tableDesc">{data.desc_p2}</p>
      <h4 className="para-2 spacer_sm">Documents required for KYC verification:</h4>
      {data.docu.map((step, id) => (
        <div className="d-f-c" key={id} style={{ marginTop: "18px" }}>
          <div>
            <span className="para-3-bold step">
              {step.name}
            </span>{" "}
            <span className="para-2">{step.desc}</span>
            {step.options && step.options.length > 0 && (
              <ul className="documentContainer">
                {step.options.map((document, id) => (
                  <li key={id} className="para-2 tableDesc">
                    {document}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      ))}
      <style jsx>{`.howToInvestWrapper{
          margin-bottom: 24px;
          padding-bottom: 32px;
      }.tableTitle{
        text-decoration: none;
      margin: 30px 0 16px;
      }.step{
        margin-bottom: 16px;
      }.documentContainer {
        margin-left: 32px;
        margin-top: 16px;
      }`}</style>
    </div>
  );
}
